"use strict";

var _set = require("babel-runtime/core-js/set");

var _set2 = _interopRequireDefault(_set);

var _getOwnPropertySymbols = require("babel-runtime/core-js/object/get-own-property-symbols");

var _getOwnPropertySymbols2 = _interopRequireDefault(_getOwnPropertySymbols);

var _assign = require("babel-runtime/core-js/object/assign");

var _assign2 = _interopRequireDefault(_assign);

var _create = require("babel-runtime/core-js/object/create");

var _create2 = _interopRequireDefault(_create);

var _setPrototypeOf = require("babel-runtime/core-js/object/set-prototype-of");

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var __extends = undefined && undefined.__extends || function () {
    var extendStatics = _setPrototypeOf2.default || { __proto__: [] } instanceof Array && function (d, b) {
        d.__proto__ = b;
    } || function (d, b) {
        for (var p in b) {
            if (b.hasOwnProperty(p)) d[p] = b[p];
        }
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? (0, _create2.default)(b) : (__.prototype = b.prototype, new __());
    };
}();
var __assign = undefined && undefined.__assign || _assign2.default || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) {
            if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
    }
    return t;
};
var __rest = undefined && undefined.__rest || function (s, e) {
    var t = {};
    for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    }if (s != null && typeof _getOwnPropertySymbols2.default === "function") for (var i = 0, p = (0, _getOwnPropertySymbols2.default)(s); i < p.length; i++) {
        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
    }return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var PropTypes = require("prop-types");
var classNames = require("classnames");
var next_1 = require("@alicd/next");
var CascaderMenu_1 = require("./CascaderMenu");
var Common_1 = require("./Common");
var AddressEntry = /** @class */function (_super) {
    __extends(AddressEntry, _super);
    function AddressEntry(props) {
        var _this = _super.call(this, props) || this;
        _this.handleMenuClick = _this.handleMenuClick.bind(_this);
        return _this;
    }
    AddressEntry.prototype.handleMenuClick = function () {
        typeof this.props.onSelect == "function" && this.props.onSelect(this.props.node);
    };
    AddressEntry.prototype.showArrow = function (props) {
        if (props === void 0) {
            props = this.props;
        }
        if (props.maxLevel && Common_1.getNodeLevelInTree(props.node) >= props.maxLevel) {
            return false;
        }
        return !props.node.isLeaf;
    };
    AddressEntry.prototype.render = function () {
        var _a = this.props,
            node = _a.node,
            onSelect = _a.onSelect,
            active = _a.active,
            selected = _a.selected,
            maxLevel = _a.maxLevel,
            rest = __rest(_a, ["node", "onSelect", "active", "selected", "maxLevel"]);
        return React.createElement(CascaderMenu_1.default.Item, __assign({ key: node.id.toString(), className: classNames("cn-addr-casitem", { "cn-addr-casactive": this.props.active }), onClick: this.handleMenuClick }, rest), selected ? React.createElement(next_1.Icon, { className: "cn-addr-caselect", type: "select", size: "xs" }) : null, React.createElement("span", { className: "cn-addr-castext" }, Common_1.getLabelIntl(node)), !this.showArrow() ? null : React.createElement(next_1.Icon, { className: "cn-addr-casexpand", type: "arrow-right", size: "xs" }));
    };
    AddressEntry.propTypes = {
        node: PropTypes.object,
        onSelect: PropTypes.func,
        active: PropTypes.bool,
        selected: PropTypes.bool,
        maxLevel: PropTypes.number
    };
    return AddressEntry;
}(React.Component);
var CNAddressIntlCascader = /** @class */function (_super) {
    __extends(CNAddressIntlCascader, _super);
    function CNAddressIntlCascader(props) {
        var _this = _super.call(this, props) || this;
        _this.activeChainSet = new _set2.default();
        _this.renderMenu = _this.renderMenu.bind(_this);
        _this.handleSelect = _this.handleSelect.bind(_this);
        return _this;
    }
    CNAddressIntlCascader.prototype.handleSelect = function (node) {
        typeof this.props.onChange == "function" && this.props.onChange(node.id);
    };
    CNAddressIntlCascader.prototype.renderMenu = function (node, zIndex, activeChainSet) {
        var _this = this;
        if (node.isLeaf) {
            return null;
        } else if (!node.children) {
            return null;
        }
        var selectedNodeId = Common_1.selectionToId(this.props.value);
        return React.createElement(CascaderMenu_1.default, { className: "cn-addr-caslist", key: node.id.toString(), style: { zIndex: zIndex } }, node.children.map(function (child) {
            return React.createElement(AddressEntry, { key: child.id.toString(), node: child, onSelect: _this.handleSelect, active: activeChainSet.has(child.id), selected: child.id == selectedNodeId, maxLevel: _this.props.maxLevel });
        }));
    };
    CNAddressIntlCascader.prototype.render = function () {
        var _this = this;
        var nodeId = Common_1.selectionToId(this.props.value);
        var node = this.props.addressStore.impl.getNodeByIdSync(nodeId);
        var nodeChain = Common_1.nodeChainFromNode(node);
        var rootPos = nodeChain.findIndex(function (n) {
            return n.id == _this.props.rootNodeId;
        });
        if (rootPos != -1) {
            nodeChain = nodeChain.slice(rootPos);
        }
        this.activeChainSet = new _set2.default();
        nodeChain.forEach(function (v) {
            return _this.activeChainSet.add(v.id);
        });
        var menus = nodeChain.filter(function (node) {
            return !_this.props.maxLevel || Common_1.getNodeLevelInTree(node) < _this.props.maxLevel;
        }).map(function (node, idx) {
            return _this.renderMenu(node, nodeChain.length - idx + 12, _this.activeChainSet);
        });
        return React.createElement("span", { className: "cn-addr-casmenu cn-addr-casmenu-iu" }, menus);
    };
    CNAddressIntlCascader.propTypes = {
        value: PropTypes.arrayOf(PropTypes.string),
        onChange: PropTypes.func,
        rootNodeId: PropTypes.string,
        maxLevel: PropTypes.number,
        addressStore: PropTypes.object
    };
    CNAddressIntlCascader.defaultProps = { value: [] };
    return CNAddressIntlCascader;
}(React.Component);
exports.default = CNAddressIntlCascader;
//# sourceMappingURL=CNAddressIntlCascader.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@alicd_crui-address@0.0.80@@alicd/crui-address/lib/CNAddressIntlCascader.js
// module id = 581
// module chunks = 0